import React, { useEffect, useMemo, useState } from 'react';
import { HistorialFirmaAvisoEntrada } from '../TypesFirmaAvisoEntrada';
import { Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import Cargando from 'components/Varios/Cargando';
import TablaHistorialAvisoEntrada from './TablaHistorialAvisoEntrada';
import { ObtenerHistorialFirmaDocumentoPazSalvo, ObtenerYearsHistorialFirmaDocumentoPazSalvo, URL_ANIOS_HISTORIAL_FIRMA, URL_REPORTE_HISTORIAL_FIRMA } from '../FunctionsFirmaAvisoEntrada';
import { alertService } from 'components/Varios/alert_service';

export default function HistorialAvisoEntrada() {

    const [historial, sethistorial] = useState<HistorialFirmaAvisoEntrada[]>([]);
    const [loading, setloading] = useState(false);
    const [anioSeleccionado, setanioSeleccionado] = useState<number>(-1)

    async function ConsultarHistorialAnio(anio: number) {
        setloading(true);
        const respuesta = await ObtenerHistorialFirmaDocumentoPazSalvo(anio);
        if (respuesta.status === 200 && respuesta.dataResponse !== undefined) {
            sethistorial(respuesta.dataResponse);
        }
        else {
            const mensajeError = respuesta.errorMessage ?? "No ha sido posible obtener información del historial de firma de documentos de aviso de entrada";
            alertService.error(mensajeError);
        }
        setloading(false);
    }

    async function ObtenerInformacionHistorial() {
        setloading(true);
        const aniosRespuesta = await ObtenerYearsHistorialFirmaDocumentoPazSalvo();

        if (aniosRespuesta.status === 200 && aniosRespuesta.dataResponse !== undefined) {

            const aniosConsulta: number[] = aniosRespuesta.dataResponse;

            if (aniosConsulta.length > 0) {
                setanioSeleccionado(aniosConsulta[0])
            }
            else {
                setloading(false);
            }
        }
        else {
            const mensajeError = aniosRespuesta.errorMessage ?? "No ha sido posible obtener información del historial de firma de documentos de aviso de entrada";
            alertService.error(mensajeError);
            setloading(false);
        }
    }

    useEffect(() => {
        ObtenerInformacionHistorial();
    }, []);

    useEffect(() => {
        if (anioSeleccionado >= 0) {
            ConsultarHistorialAnio(anioSeleccionado)
        }
    }, [anioSeleccionado])

    const TablaHistorialAS = useMemo(() => {
        if (loading) {
            return <Cargando />;
        }
        else {
            return (
                <TablaHistorialAvisoEntrada
                    informacion={historial}
                    apiReporte={URL_REPORTE_HISTORIAL_FIRMA}
                    apiYearsReporte={URL_ANIOS_HISTORIAL_FIRMA}
                    anioSeleccionado={anioSeleccionado}
                    onChangeAnio={(anio: number) => setanioSeleccionado(anio)} />
            );
        }
    }, [loading, historial, anioSeleccionado]);

    return (
        <div className="content">
            <>
                <Row>
                    <Col>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className='title'> Historial Firma Documento Aviso de Entrada </h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                {TablaHistorialAS}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </>
        </div>
    );
}